module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_3016.03a34287.png";